import { render } from "./list-service.vue?vue&type=template&id=019ddcbc&scoped=true"
import script from "./list-service.vue?vue&type=script&lang=js"
export * from "./list-service.vue?vue&type=script&lang=js"

import "./list-service.vue?vue&type=style&index=0&id=019ddcbc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-019ddcbc"]])

export default __exports__